import { PRODUCT_TYPE, SUPPORTED_PRODUCT_TYPES } from '../model/productType';

import RestClient from './RestClient';

export interface UserResponse {
  account_id: string;
  email: string;
  locale?: string;
  name: string;
  picture: string;
}

export interface Collaborator {
  avatarUrl?: string;
  displayName: string;
  relevance?: number;
}

export interface JoinableSite {
  cloudId: string;
  displayName: string;
  products: JoinableSiteProducts | PRODUCT_TYPE[];
  relevance?: number;
  size?: number;
  url: string;
}

export type JoinableSiteProducts = { [key in PRODUCT_TYPE]?: JoinableSiteProductData };

export interface JoinableSiteProductData {
  collaborators: Collaborator[];
  productUrl?: string;
}

export interface JoinableSitesResponse {
  joinableSites: JoinableSite[];
}

export interface ExperimentalJoinableSitesResponse {
  sites: JoinableSite[];
}

export interface ProductContext {
  productKey: 'jira' | 'confluence';
  siteId: string;
}

interface JoinableSitesRequestData {
  products: string[];
  userRecommendationContext?: { productKey: string; siteId: string };
}

class IdentityClient extends RestClient {
  getJoinableSites(): Promise<JoinableSitesResponse> {
    return this.postResource('/gateway/api/joinable-sites', { products: SUPPORTED_PRODUCT_TYPES });
  }
  // The new endpoint responds with a `sites` field instead of a `joinableSites` field.
  // When we only rely on one of the endpoints this will be removed.
  // https://atl-growth.atlassian.net/browse/TED-85
  getJoinableSitesWithCollaborators(context?: ProductContext): Promise<ExperimentalJoinableSitesResponse> {
    const requestData: JoinableSitesRequestData = {
      products: SUPPORTED_PRODUCT_TYPES,
    };
    if (context) {
      requestData.userRecommendationContext = {
        productKey: context.productKey,
        siteId: context.siteId,
      };
    }
    return this.postResource('/gateway/api/growth/trello-cross-product-join/recommended-sites', requestData);
  }
  getUser(): Promise<UserResponse> {
    return this.getResource('/gateway/api/me');
  }
}

export default new IdentityClient();
